<template>
  <!-- <vx-card> -->
    <div>
      <!-- <pre>{{productsFiltered}}</pre> -->
    <vs-prompt
      title="Export To Excel"
      class="export-options"
      @cancle="clearFields"
      @accept="exportToExcel"
      accept-text="Export"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <div class="export-table">
      <vs-table pagination max-items="5" search :data="productsFiltered">
        <template slot="header">
          <!-- <vs-button @click="activePrompt = true">Export</vs-button> -->
          <vs-button @click="exportToExcel()">Download as CSV</vs-button>
        </template>

        <template slot="thead">
          <vs-th> Name </vs-th>
          <vs-th> Code </vs-th>
          <vs-th>{{payload.filterType !== 'overall' ? 'Competitor ' : ''}}Priced</vs-th>
          <vs-th> Price </vs-th>
          <vs-th> Best Price</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">{{ data[indextr].name | ellipsis(15)}}</vs-td>
            <vs-td :data="data[indextr].code">{{ data[indextr].code }}</vs-td>
            <vs-td :data="data[indextr].pos">{{ getPos(data[indextr].pos) }}</vs-td>
            <vs-td :data="data[indextr].price">{{ data[indextr].price | numFormat('$ 0,0')}}</vs-td>
            <vs-td :data="data[indextr].bestPrice">{{ data[indextr].bestPrice | numFormat('$ 0,0')}}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    </div>
  <!-- </vx-card> -->
</template>

<script>
import vSelect from 'vue-select'
import { fetchArtefacts } from "../shared/services";

export default {
  components: {
    vSelect
  },
  props: {
      payload: { type: Object, required: true }
  },
  data() {
    return {
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'csv',
      headerTitle: ['name', 'code', 'pos', 'bestPrice', 'price' ],
      headerVal: ['name', 'code', 'pos', 'bestPrice', 'price' ],
      products: [
        // {
        //   'product_name': 'Teeling Single Grain 46% 700ml',
        //   'product_code': 'LMDW010',
        //   'isc': 0,
        //   'CTS': 89.67115384615384,
        //   'alco': 100.0,
        //   'paneco': 109.99,
        //   'cell': 104.0,
        //   'asher': 95.0,
        //   'kris': 0,
        //   'wns': 0,
        //   'fp': 0,
        //   'tls': 105.0,
        //   'amp': 100.61019230769232,
        //   'max_price': 109.99,
        //   'min_price': 89.67115384615384,
        //   'second_highest': 109.99,
        //   'second_lowest': 95.0,
        //   'high': 0.0,
        //   'low': 5.609999999999999,
        //   'hamp': 9.32,
        //   'lamp': 10.870000000000001,
        //   'high_bins': 0,
        //   'low_bins': '5-10%',
        //   'hamp_bins': '5-10%',
        //   'lamp_bins': '10-20%',
        //   'cts_high': 0,
        //   'cts_low': 1
        // }
      ],
      productsFilteredForExport: [],
      activePrompt: false,

      isLoading: true,
      // payload: {
      //   tags: [],
      //   dateRange: {
      //     startDate: "05/03/2019",
      //     endDate: "08/03/2019"
      //   },
      //   page: {
      //     size: 20,
      //     pos: 1
      //   },
      //   query: '',
      //   mode: "quantity",
      //   type: "PGA",
      //   res: {}
      // },
    }
  },
  methods: {
    getPos(pos) {
      if(this.payload.filterType === 'overall') {
        return pos === 'down' ? 'High' : 'Low'
      } else {
        return pos === 'down' ? 'Low' : 'High'
      }
    },
    getFilteredStockInfo() {
      this.isLoading = true;
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#exploreButton",
        // scale: 0.45,
        type: "radius"
      });
      let payloadCopy = Object.assign([], this.payload)
      payloadCopy.page.pos = 1
      payloadCopy.page.size = 2000
      fetchArtefacts(payloadCopy)
        .then(res => {
          this.productsFilteredForExport = [];
          
          let skus = res.data.skus.map(item =>
            (item._source ? item._source : item[0])
          );
          this.products = skus
          this.stats = res.data.stats;

          this.isLoading = false;
          
          this.$vs.loading.close();
        })
        .catch(error => {
          this.products = [];
          this.productsFilteredForExport = [];
          this.isLoading = false;
          this.$vs.loading.close();
          throw new Error(error);
        });

    },

    exportToExcel() {
      import('@/plugins/Export2Excel').then(excel => {
        const list = this.productsFilteredForExport
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j]
        })
      )
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'csv'
    }
  },
  computed: {
    productsFiltered() {
      let skus = this.products
      let tags = [];

      // if(payload.tags) {
      //   for(var tag of payload.tags) {
      //     if(tag.type === 'E') {
      //       tags.push(tag.tag.trim().replace(/ /g, "_").toLowerCase());
      //     }
      //   }
      // }
      // if(payload.filterType === 'specific') {
      //   if(payload.filterScope && payload.filterScope.mode) {
      //     for(let tag of tags) {
      //       flagList.push(tag+ '_'+(payload.filterScope.mode.trim().replace(/ /g, "_").toLowerCase()));
      //     }
      //   }
      // } else if(payload.filterType === 'overall') {
      //   if(payload.filterScope) {
      //     const code = payload.filterScope.code.trim().replace('%', '').toLowerCase();
      //     let mode = '';
      //     if(payload.filterScope.mode.trim().toLowerCase() === 'low') {
      //       mode =  payload.filterRef === 'AVG' ? 'lamp_bins' : 'low_bins'
      //     } else {
      //       mode =  payload.filterRef === 'AVG' ? 'hamp_bins' : 'high_bins'
      //     }
      //     if(code !== 'all') {
      //       flagList.push(code+'_'+mode)
      //     } else {
      //       if(payload.filterScope.mode.trim().toLowerCase() === 'low') {
      //         flagList.push('cts_low')
      //       } else {
      //         flagList.push('cts_high')
      //       }
      //     }
      //   }
      // }


      // if(this.filter.type === 'cts_low') {
      //   bucket = 'low_bins'
        this.fileName = 'SKUs Priced the Lowest @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY')
      // } else {
      //   this.fileName = 'SKUs Priced the Highest @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY')
      // }
      // skus.sort(function (x, y) {
      //   let xLabelParts = x[bucket].split('-')
      //   let yLabelParts = y[bucket].split('-')
      //   return isNaN(xLabelParts[0])  ? -1 : yLabelParts[0] - xLabelParts[0];
      // });

      this.productsFilteredForExport = skus;

      return skus;
    }
  },
  mounted() {
    this.getFilteredStockInfo();
  }  
}
</script>
